import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        room_service_visible: {
          label: 'Serviço de quarto/mesa visível',
        },
        has_room_service: {
          label: 'Serviço de quarto/mesa',
        },
      },
    },
    settings: {
      title: 'Definições',
      table_number: {
        label: 'Mostrar número de mesa',
      },
    },
    locations: {
      title: 'Localizações',
    },
  },
  form: {
    google_place: {
      label: 'Nome',
      placeholder: 'Nome no Google Maps',
    },
    type: {
      label: 'Tipo',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviço de quarto',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviço de mesa',
      },
    },
    name: {
      label: 'Nome da localização',
      placeholder: 'Introduza o nome da localização que será claro para o cliente',
    },
    street_name: {
      label: 'Rua',
      placeholder: 'Nome da rua',
    },
    street_number: {
      label: 'Número',
      placeholder: 'Número',
    },
    city: {
      label: 'Cidade',
      placeholder: 'Cidade',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
  },
  fields: {
    id: 'id',
    type: 'Tipo',
    name: 'Nome',
    address: 'Morada',
    is_active: 'Ativo',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviço de quarto',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviço de mesa',
  },
  modals: {
    delete_location: {
      title: 'Tem a certeza?',
      description: 'Isto irá eliminar a localização «{{name}}»',
    },
  },
  buttons: {
    save: 'Guardar',
    delete: 'Eliminar',
  },
  toasts: {
    failed_to_load_locations: 'Erro ao carregar localizações, por favor recarregue a página',
    failed_to_create_location: 'Erro ao criar localização',
    failed_to_toggle_location: 'Erro ao alterar disponibilidade da localização',
    failed_to_delete_location: 'Erro ao eliminar localização',
    location_got_created: 'Localização criada com sucesso',
    location_got_deleted: 'Localização eliminada',
    saving_success: 'Guardado com sucesso',
    saving_error: 'Erro ao guardar',
  },
};
